import { render, staticRenderFns } from "./addVisit.vue?vue&type=template&id=5995b8a2&"
import script from "./addVisit.vue?vue&type=script&lang=js&"
export * from "./addVisit.vue?vue&type=script&lang=js&"
import style0 from "./addVisit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports